import type { FormattedCellValue } from '@/components/CompositeField/formattedCellValue';

/**
 * Splits an export text value into an ExcelJS cell value, with hyperlink when it holds one.
 * - `FormattedCellValue` `{ display, url }` → `{ text: display, hyperlink: url }`.
 * - A multiline `string` whose last line is `http(s)://…` → first line is cell text, last
 *   line is the link target; single-line and non-URL last lines stay plain strings.
 */
export function exceljsStringCellValueWithOptionalLastLineHyperlink(
  value: FormattedCellValue,
): string | { text: string; hyperlink: string } {
  if (typeof value === 'object') {
    return { text: value.display, hyperlink: value.url };
  }
  const lines = value.split('\n');
  if (lines.length < 2) return value;
  const firstLine = lines[0]?.trim() ?? '';
  if (!firstLine) return value;
  const last = lines[lines.length - 1].trim();
  if (!/^https?:\/\//i.test(last)) return value;
  return { text: firstLine, hyperlink: last };
}
